export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'DEGREE_TEMPLATE',
        data => ({
            id: data.id,
            school_id: data.school_id,
            profile_id: data.profile_id,
            field_id: data.field_id,
            level_id: data.level_id,
            title: data.title,
            school: data.school,
            field: data.field,
            level: data.level,
            start: data.start,
            end: data.end,
        }),
    ],
    authorize: true,

    POST: {},

    '/:id': {
        PUT: {},
        DELETE: {},
    },
};
